var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.505 5.673A1.453 1.453 0 10.4 7.677l4.36 4.579a1.453 1.453 0 002.04.063l6.72-8.051a1.453 1.453 0 00-1.978-2.13L6.435 7.205a1 1 0 01-1.231.14L2.505 5.673z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNTA1MjUgNS42NzMyM0MxLjk1MjA1IDUuMDkyMDIgMS4wMzI0MiA1LjA2OTMxIDAuNDUxMjEgNS42MjI1MUMtMC4xMzAwMDMgNi4xNzU3MiAtMC4xNTI3MSA3LjA5NTM0IDAuNDAwNDkzIDcuNjc2NTZMNC43NTkxIDEyLjI1NTlDNS4zMDc0OSAxMi44MzIgNi4yMTcyMiAxMi44NjAxIDYuODAwMDkgMTIuMzE4OEwxMy41MTk2IDQuMjY3NTNDMTQuMTA3NiAzLjcyMTU0IDE0LjE0MTYgMi44MDIyNiAxMy41OTU3IDIuMjE0MjdDMTMuMDQ5NyAxLjYyNjI4IDEyLjEzMDQgMS41OTIyMyAxMS41NDI0IDIuMTM4MjJMNi40MzQ2IDcuMjA0NjFDNi4xMDYxNCA3LjUzMDQgNS41OTcwOSA3LjU4ODM2IDUuMjAzNzkgNy4zNDQ3NUwyLjUwNTI1IDUuNjczMjNaIiAvPgo8L3N2Zz4K";
export { SvgTick as ReactComponent };